import { getWhere, parentTreeItem } from "library/tree/index.mjs"

export function getRegimeLocation(treeItem) {
    return getWhere(treeItem?.[parentTreeItem])
}
